import { CaretDownOutlined, MenuUnfoldOutlined, UserOutlined } from "@ant-design/icons";
import { Avatar, Breadcrumb, Dropdown, Menu, Space, Tag } from "antd";
import { Header } from "antd/es/layout/layout";
import logo from "assets/images/logo.png";
import clsx from "clsx";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { adminRoutes } from "router";
import { settings } from "settings";
import { userStore } from "store/userStore";
import { formatVND } from "utils";
import { $url } from "utils/url";
import { TopNavMenu } from "./Sidebar";
import { NotificationBell } from "components/Notification/NotificationBell";

const userMenu = (
  <Menu>
    <Menu.Item key="profile" icon={<UserOutlined />}>
      <Link to="/profile">Cá nhân</Link>
    </Menu.Item>
    <Menu.Item key="login">
      <Link to="/login" onClick={() => userStore.logout()}>
        Đăng xuất
      </Link>
    </Menu.Item>
  </Menu>
);

type NavbarProps = {
  toggle: () => void;
  isMobile?: boolean;
};

export const Navbar = observer(({ toggle, isMobile = false }: NavbarProps) => {
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<string[]>([]);

  useEffect(() => {
    const find = adminRoutes.find((e) => e.path == location.pathname);
    if (find) {
      if (find.breadcrumb) {
        setBreadcrumbs(find.breadcrumb.split("/"));
      } else if (find.title) {
        setBreadcrumbs([find.title]);
      }
    }
  }, [location.pathname]);

  return (
    <Header
      className={clsx("site-layout-background admin-navbar", isMobile && "admin-navbar--mobile")}
    >
      <div className="admin-navbar__left">
        {isMobile ? (
          <>
            <MenuUnfoldOutlined className="trigger" onClick={toggle} />
            <Breadcrumb className="admin-navbar__breadcrumb">
              {breadcrumbs.map((item, i) => (
                <Breadcrumb.Item key={i} className="font-semibold">
                  {item}
                </Breadcrumb.Item>
              ))}
            </Breadcrumb>
          </>
        ) : (
          <>
            <Link to="/" className="admin-navbar__brand">
              <img src={logo} alt="Logo" className="admin-navbar__logo" />
            </Link>
            <TopNavMenu />
          </>
        )}
      </div>

      <Space className="admin-navbar__actions" size={20}>
        <span className="admin-navbar__version">v{settings.version}</span>

        <NotificationBell />

        {userStore?.info?.area && (
          <Tag color="blue" className="admin-navbar__balance-tag">
            <span className="admin-navbar__balance-name">{userStore?.info?.area?.name}</span>
            <Link className="tooltip-text admin-navbar__balance-link" to="/transaction-area">
              Số dư:{" "}
              <span className="admin-navbar__balance-amount">
                {formatVND(userStore?.info?.area?.balance || 0)}đ
              </span>
            </Link>
          </Tag>
        )}

        <Dropdown trigger={["click"]} overlay={userMenu}>
          <Space className="admin-navbar__user">
            <Avatar
              size="large"
              src={$url(userStore.info.avatar)}
              className="admin-navbar__avatar"
              style={{
                objectFit: "contain",
              }}
            >
              {userStore.info.name?.[0]}
            </Avatar>
            <CaretDownOutlined className="admin-navbar__caret" />
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
});
